import React from "react";
import Navbar from "../Navbar";
import Footer from "../Footer";
import CartDrawer from "../CartDrawer";
import MobileStickyBar from "../MobileStickyBar";
import MossMatrixChatbot from "../MossMatrixChatbot";
import { ShellThemeContext } from "./ShellTheme";

/**
 * Shared chrome: nav, footer, cart. Customer journey pages use theme="dark"
 * for premium coherence with the homepage. Cart drawer stays cream for readability.
 */
export default function SiteShell({ children, theme = "light" }) {
  const dark = theme === "dark";

  return (
    <ShellThemeContext.Provider value={theme}>
      <div
        className={
          dark
            ? "mm-dark min-h-screen bg-void text-ivory overflow-x-hidden"
            : "min-h-screen bg-offwhite overflow-x-hidden"
        }
      >
        <Navbar />
        {children}
        <Footer />
        <CartDrawer />
        <MobileStickyBar />
        <MossMatrixChatbot />
      </div>
    </ShellThemeContext.Provider>
  );
}
